/* eslint-disable react/prop-types, import/no-extraneous-dependencies */
import riveWASMResource from '@rive-app/canvas/rive.wasm';
import { graphql } from 'gatsby';
import React from 'react';
import { RuntimeLoader } from 'rive-react';

import Benefits from 'components/pages/home/new/benefits';
import BentoCards from 'components/pages/home/new/bento-cards';
import Hero from 'components/pages/home/new/hero';
import Rating from 'components/pages/home/new/rating';
import CaseStudyCard from 'components/shared/case-study-card';
import Cta from 'components/shared/cta';
import Layout from 'components/shared/layout';
import PreviewBanner from 'components/shared/preview-banner';
import Products from 'components/shared/products';
import TestimonialsSlider from 'components/shared/testimonials-slider';
import getReactContentWithLazyBlocks from 'utils/get-react-content-with-lazy-blocks';

RuntimeLoader.setWasmUrl(riveWASMResource);

const HomePage = ({
  data: {
    wpPage: { content, seo },
    wpSharedBlock: { sharedBlockNewCTA: newCtaData },
  },
  pageContext,
}) => {
  const contentWithLazyBlocks = getReactContentWithLazyBlocks(content, {
    homenewhero: Hero,
    sharedproducts: Products,
    homenewbento: BentoCards,
    casestudycard: CaseStudyCard,
    homenewplatform: Benefits,
    testimonialsslider: TestimonialsSlider,
    homenewrating: Rating,
  });

  const newCta = {
    title: newCtaData.title,
    description: newCtaData.description,
    buttonText: newCtaData.buttonText,
    buttonUrl: newCtaData.buttonUrl,
    linkText: newCtaData.linkText,
    linkUrl: newCtaData.linkUrl,
  };

  return (
    <Layout
      seo={{
        ...seo,
        metaRobotsNoindex: !pageContext?.isPublished ? 'noindex' : seo?.metaRobotsNoindex,
      }}
      pageContext={pageContext}
      headerTheme="gray"
      footerTheme="gray"
    >
      {!pageContext?.isPublished && <PreviewBanner />}
      {contentWithLazyBlocks}
      <Cta {...newCta} />
    </Layout>
  );
};

export const query = graphql`
  query ($id: String!, $locale: String!) {
    wpPage(id: { eq: $id }) {
      content
      ...wpPageSeo
    }

    wpSharedBlock(slug: { eq: "new-cta" }, language: { locale: { eq: $locale } }) {
      sharedBlockNewCTA {
        title
        description
        buttonText
        buttonUrl
        linkText
        linkUrl
      }
    }
  }
`;

export const Head = () => (
  <>
    <link rel="preload" href={`${riveWASMResource}`} as="fetch" crossOrigin="anonymous" />
    <link rel="preload" href="/animations/home/hero.riv" as="fetch" crossOrigin="anonymous" />
  </>
);

export default HomePage;
